import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from "@/components/ui/dialog"
import { ReactNode } from "react"

export interface ModalProps {
  open: boolean
  setOpen: (open: boolean) => void
}

interface StyledDialogProps extends ModalProps {
  title: string
  description?: string
  content: ReactNode
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl" | "5xl"
  footerButtons?: {
    hideClose?: boolean
    primary?: {
      text: string
      onClick: () => void
      loading?: boolean
      disabled?: boolean
    }
    secondary?: {
      text: string
      onClick?: () => void
    }
  }
}

export function StyledDialog({
  open,
  setOpen,
  title,
  description,
  content,
  maxWidth = "md",
  footerButtons,
}: StyledDialogProps) {
  const maxWidthClass = {
    xs: "sm:max-w-xs",
    sm: "sm:max-w-sm",
    md: "sm:max-w-md",
    lg: "sm:max-w-lg",
    xl: "sm:max-w-xl",
    "2xl": "sm:max-w-2xl",
    "3xl": "sm:max-w-3xl",
    "4xl": "sm:max-w-4xl",
    "5xl": "sm:max-w-5xl",
  }[maxWidth]

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className={maxWidthClass}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>

        {content}

        <DialogFooter className="justify-between">
          {!footerButtons?.hideClose &&
            <DialogClose asChild>
              <Button type="button" variant="outline" onClick={() => setOpen(false)}>
                Close
              </Button>
            </DialogClose>

          }
          {footerButtons?.secondary && (
            <DialogClose asChild>
              <Button
                type="button"
                variant="outline"
                onClick={footerButtons.secondary.onClick}
              >
                {footerButtons.secondary.text}
              </Button>
            </DialogClose>
          )}

          {footerButtons?.primary && (
            <Button
              onClick={footerButtons.primary.onClick}
              disabled={footerButtons.primary.disabled}
            >
              {footerButtons.primary.text}
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}